/* eslint semi:0 */
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import { makeImage } from '../../../utils/dom'
import { getPlatform } from '../../../utils/ua'
import m from 'mithril'
import { adStore } from '../../stores/adStore'

const HOST = 'ec2-54-185-154-151.us-west-2.compute.amazonaws.com'

class AnalyticsCounterService extends AnalyticsBaseService {
  get className() {
    return 'AnalyticsCounterService'
  }

  pageViewed() {
    this.trackEvent('pageview', { platform: getPlatform() })
  }

  routeChanged(action) {
    //Empty override to prevent a read report on slideshows on each slide change
  }

  adBlockDetectionFinished() {
    this.trackEvent('adblock', {
      platform: getPlatform(),
      adblock_detected: adStore.isAdblockPresent,
    })
  }

  slotRendered(action) {
    let lineitem
    if (action.event.isEmpty) {
      lineitem = 'empty'
    } else {
      lineitem = action.event.lineItemId || 'adx'
    }
    this.trackEvent('ad_served', {
      platform: getPlatform(),
      ad_unit: action.adId,
      lineitem: lineitem,
    })
  }

  trackEvent(type, params) {
    for (let k in params) {
      params[k] = params[k].toString().replace(' ', '-')
    }
    params.ts = Date.now()
    this.logAnalytics(type, params)
    let serializedParams = m.route.buildQueryString(params)
    makeImage({ src: `//${HOST}/${type}?${serializedParams}` })
  }
}

export default AnalyticsCounterService



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/analyticsCounterService.js